<vs-dialog #duplicatePlanDialog [config]="dialogConfig ?? { dialogContainerClass: 'max-w-[525px]' }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      hideCloseButton: false,

      icon: 'copy-04',
      iconTheme: 'primary',

      title: 'Duplicate Plan',
      subtitle: 'The copy keeps the same coverages, deductibles, limits and pricing.'
    }"
  ></vs-dialog-header>

  <p class="text-sm text-gray-700 mb-4">Duplicating <span class="font-semibold">{{ plan?.title }}</span></p>

  <form class="flex flex-col gap-4" [formGroup]="form">
    <vs-form-field [config]="{ label: { text: 'Title', for: 'title-input' } }">
      <input vsInput id="title-input" type="text" formControlName="title" />
    </vs-form-field>
  </form>

  <div *ngIf="policy?.status !== draftStatus" class="flex gap-2 text-sm text-danger-500 mt-4">
    <vs-icon class="self-center" name="alert-circle" size="md"></vs-icon>
    <span class="self-center">
      Duplicating will create a new policy version, the current policy will not be modified
    </span>
  </div>

  <!-- Buttons -->
  <div class="footer mt-4">
    <div class="buttons flex space-x-4">
      <button class="flex-grow" vs-button size="md" appearance="outline" [disabled]="saving" (click)="cancel()">
        Cancel
      </button>
      <button
        class="flex-grow"
        vs-button
        size="md"
        theme="primary"
        [disabled]="saving || form.invalid"
        (click)="duplicatePlan()"
      >
        Duplicate
      </button>
    </div>
  </div>
</vs-dialog>
